import { call, put, select } from 'redux-saga/effects';
import { errorHandler } from '../errorSaga';
import {
  getMessagesRequestStartLoading,
  getMessagesRequestStopLoading,
  openMessageModal,
} from '../../actions/messageActions';
import { getMessages, markAsRead } from '../../../api/messageApi';
import { compareByIsImportant } from './common';
import { MESSAGE_TYPE } from '../../../constants';
import Logger from '../../../services/Logger';
import { doneRequestSequentialModal } from '../../actions';
import { SEQUENTIAL_MODALS } from '../../../constants/sequentialModals';

function* callMarkAsOpenModal({ messageId }) {
  try {
    yield call(markAsRead, { messageId, requestBody: { isOpenModal: true } });
  } catch (e) {
    // throwしない
    Logger.error(e);
  }
}

export function* openMessageModalRequestHandler({ payload }) {
  try {
    const isAuthenticated = yield select((state) => state.auth.isAuthenticated);
    if (!isAuthenticated) {
      // 未ログイン時はスキップ
      return;
    }

    const { isIndividual, channel } = payload;
    yield put(getMessagesRequestStartLoading());
    const { data: messages } = yield call(getMessages, { isIndividual, channel });
    const found = messages
      ?.filter(
        (m) =>
          m.isPopupEnabled &&
          !m.status?.readFlg &&
          m.type?.messageType === MESSAGE_TYPE.NOTIFICATION &&
          (m.isImportant || !m.status?.modalCount),
      )
      .sort(compareByIsImportant)
      .find(() => true);
    if (found) {
      yield put(openMessageModal({ message: found }));
      yield* callMarkAsOpenModal({ messageId: found.messageId });
    } else {
      yield put(doneRequestSequentialModal({ modalId: SEQUENTIAL_MODALS.MessageModal }));
    }
  } catch (error) {
    yield call(errorHandler, { error });
  } finally {
    yield put(getMessagesRequestStopLoading());
  }
}
